import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OrdersSettingsInterface } from '@shared/components/trading/widgets/orders-widget/core/interfaces/orders-settings.interface'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { OrderStateEnum } from '@modules/orders-module/enums/order-state.enum'
import { DropdownColumnsActionsComponent } from '@shared/components/trading/widgets/common/dropdown-columns-actions/dropdown-columns-actions.component'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsOpenedOrdersEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/stocks/columns-opened-orders.enum'
import { ColumnsCanceledOrdersEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/stocks/columns-canceled-orders.enum'
import { ColumnsFilledOrdersEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/stocks/columns-filled-orders.enum'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'

@UseLocales({ ru, en })
@Component({
	selector: 'app-dropdown-columns-orders-stocks',
	templateUrl: './dropdown-columns-orders-stocks.component.html',
	styleUrl: './dropdown-columns-orders-stocks.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DropdownColumnsActionsComponent],
})
export class DropdownColumnsOrdersStocksComponent {
	protected readonly orderStateEnum: typeof OrderStateEnum = OrderStateEnum

	public widget: InputSignal<WidgetInterface<OrdersSettingsInterface> | null> =
		input<WidgetInterface<OrdersSettingsInterface> | null>(null)

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected openColumns: Signal<ColumnInterface<ColumnsOpenedOrdersEnum>[]> = computed<
		ColumnInterface<ColumnsOpenedOrdersEnum>[]
	>((): ColumnInterface<ColumnsOpenedOrdersEnum>[] => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		return widget?.settings.stocks.open.columns ?? []
	})

	protected canceledColumns: Signal<ColumnInterface<ColumnsCanceledOrdersEnum>[]> = computed<
		ColumnInterface<ColumnsCanceledOrdersEnum>[]
	>((): ColumnInterface<ColumnsCanceledOrdersEnum>[] => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		return widget?.settings.stocks.canceled.columns ?? []
	})

	protected filledColumns: Signal<ColumnInterface<ColumnsFilledOrdersEnum>[]> = computed<
		ColumnInterface<ColumnsFilledOrdersEnum>[]
	>((): ColumnInterface<ColumnsFilledOrdersEnum>[] => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		return widget?.settings.stocks.filled.columns ?? []
	})
	protected onChangeOpenColumns(columns: ColumnInterface<ColumnsOpenedOrdersEnum>[]): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				stocks: {
					...widget.settings.stocks,
					open: { columns },
				},
			},
		})
	}

	protected onChangeCanceledColumns(columns: ColumnInterface<ColumnsCanceledOrdersEnum>[]): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				stocks: {
					...widget.settings.stocks,
					canceled: { columns },
				},
			},
		})
	}

	protected onChangeFilledColumns(columns: ColumnInterface<ColumnsFilledOrdersEnum>[]): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()

		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				stocks: {
					...widget.settings.stocks,
					filled: { columns },
				},
			},
		})
	}
}
